import { axiosInstanceWithAuth } from '../../../services/axios-instance';

export const deleteAccountService = (userId: number) =>
  axiosInstanceWithAuth.delete(`/user/${userId}`);
